// CardParceiros.js

import React from 'react';
import { Card, CardContent, CardMedia, Typography, Button, Box } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import LinkIcon from '@mui/icons-material/Link';

function CardParceiros({ src, text, label, path, pathb }) {
  const handleClickLink = () => {
    window.open(pathb, '_blank');
  };

  const handleClickEmail = () => {
    window.open(path, '_blank');
  };

  return (
    <Card sx={{
      maxWidth: 345,
      borderRadius: 2,
      boxShadow: 3,
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
      '&:hover': {
        transform: 'scale(1.05)',
        boxShadow: 6,
      }
    }}>
      <CardMedia
        component="img"
        height="200"
        image={src}
        alt={text}
        sx={{ borderTopLeftRadius: 2, borderTopRightRadius: 2 }}
      />
      <CardContent>
        <Typography variant="h6" component="div" gutterBottom sx={{ fontWeight: 'bold' }}>
          {text}
        </Typography>
        <Typography variant="body2" color="textSecondary" paragraph sx={{ fontSize: '0.9rem' }}>
          {label}
        </Typography>
        <Box sx={{
          display: 'flex',
          gap: 1,
          justifyContent: 'space-between',
          flexDirection: { xs: 'column', sm: 'row' },
        }}>
          <Button 
            variant="contained" 
            color="primary" 
            startIcon={<LinkIcon />} 
            onClick={handleClickLink} 
            fullWidth
            sx={{
              textTransform: 'none',
              padding: '8px 16px',
              fontWeight: 'bold',
            }}
          >
            Visitar Site
          </Button>
          <Button 
            variant="contained" 
            color="secondary" 
            startIcon={<EmailIcon />} 
            onClick={handleClickEmail} 
            fullWidth
            sx={{
              textTransform: 'none',
              padding: '8px 16px',
              fontWeight: 'bold',
            }}
          >
            Enviar E-mail
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}

export default CardParceiros;
